import { types } from 'mobx-state-tree';
import isEqual from 'lodash.isequal';
import flatten from 'lodash.flatten';
import GroupedOptionModel from './GroupedOptionModel';

const GroupedCheckboxFilterModel = types
    .model('GroupedOptions', {
        name: types.string,
        title: types.string,
        options: types.array(GroupedOptionModel),
        type: types.literal('GroupedCheckbox'),
        value: types.array(types.string),
    })
    .views(self => ({
        get selectedOptions() {
            return flatten(
                self.options.map(opt =>
                    flatten([opt.parentOption, opt.childOptions.map(child => child)])
                )
            ).filter(option => self.value.includes(option.value));
        },

        get valueForQuery() {
            return [...self.value].length ? [...self.value] : [];
        },

        isMatch(value = []) {
            return isEqual(self.valueForQuery, value);
        },

        isParentOption(value) {
            return self.options.map(o => o.parentOption.value).includes(value);
        },

        isChildOption(value) {
            return flatten(self.options.map(o => o.childOptions.map(c => c.value))).includes(value);
        },

        getParentOfChild(value) {
            return self.options.find(o => o.childOptions.map(c => c.value).includes(value))
                .parentOption;
        },
    }))
    .actions(self => ({
        setValue(value = []) {
            self.value = value;
        },

        clear(optionValue) {
            self.value.remove(optionValue);
        },

        reset() {
            self.value = [];
        },
    }));

export default GroupedCheckboxFilterModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/GroupedCheckboxFilterModel.js